export enum EZoneType {
    Indoor = 1,
    Outdoor = 2
}
